import { render, staticRenderFns } from "./sysNotDetail.vue?vue&type=template&id=bca5af5e&scoped=true&"
import script from "./sysNotDetail.vue?vue&type=script&lang=js&"
export * from "./sysNotDetail.vue?vue&type=script&lang=js&"
import style0 from "./sysNotDetail.vue?vue&type=style&index=0&id=bca5af5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca5af5e",
  null
  
)

export default component.exports